export const SYNDIGO_SCRIPT = 'syndigoScript'
export const SYNDIGO_SITE_ID = 'fa6efff8-9151-0840-1836-2fbf5ceff704'
